(function () {
  "use strict";

  var center = document.querySelector("[data-rehair-custom-center]");
  if (!center) return;

  document.body.classList.add("rehair-custom-center-page");

  center.addEventListener("click", function (event) {
    var link = event.target.closest("[data-rehair-event]");
    if (!link) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: link.getAttribute("data-rehair-event"),
      shopping_path: link.getAttribute("data-custom-path") || "custom_center",
      page_path: window.location.pathname,
    });
  });
})();
